<template>
    <div class="vrm-modal mfp-with-anim vrm-modal--download-victronconnect">
        <div class="vrm-modal__content">
            <div class="vrm-modal__title-icon sg-vrm-icon_042_download-16px"></div>
            <div class="vrm-modal__title">
                {{
                    $t('overview.download_victronconnect_modal_title', {
                        i18nFallback: 'You need to download VictronConnect',
                    })
                }}
            </div>
            <div class="vrm-modal__text">
                {{
                    $t('overview.download_victronconnect_modal_text', {
                        i18nFallback:
                            'VictronConnect lets you get live status information and configure any Victron products which either have Bluetooth built-in, or are connected to a VE.Direct Bluetooth Smart Dongle.',
                    })
                }}
            </div>
            <div class="vrm-modal__subtitle">
                {{
                    $t('overview.download_app', {
                        i18nFallback: 'Download the app below',
                    })
                }}
            </div>
            <div class="downloads-grid">
                <a
                    target="_blank"
                    href="https://itunes.apple.com/us/app/victron-connect/id943840744?mt=8"
                >
                    <img src="/img/vc-appstore.png" width="124" />
                </a>
                <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=com.victronenergy.victronconnect"
                >
                    <img src="/img/vc-google-play.png" width="142" />
                </a>
                <a
                    target="_blank"
                    href="https://itunes.apple.com/us/app/victronconnect/id1084677271?ls=1&mt=12"
                >
                    <img src="/img/vc-mac-app.png" width="131" />
                </a>
                <a
                    target="_blank"
                    href="https://updates.victronenergy.com/feeds/VictronConnect/windows/w7/VictronConnectInstaller.exe"
                >
                    <img src="/img/vc-windows.png" width="157" />
                </a>
            </div>
            <button type="button" class="sg-btn sg-site" @click.prevent="$emit('close')">
                {{
                    $t('overview.close_without_downloading', {
                        i18nFallback: 'Close without downloading',
                    })
                }}
            </button>
        </div>
        <modal-close-handle />
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: { ModalCloseHandle },
})
@AngularLocaleBundle('overview')
export default class DownloadVictronConnectModal extends Vue {}
</script>
